export const UserRole = {
    SUPER_USER: "SUPER_USER",
    ADMINISTRATOR: "ADMINISTRATOR",
    REGULAR: "REGULAR",
    TECHNICAL_USER: "TECHNICAL_USER",
};

export const UserType = {
    CUSTOMER: "CUSTOMER",
    TAXCONSULTANT: "TAXCONSULTANT",
    AGENCY: "AGENCY",
};

export const UserTypeDisplayNames = {
    [UserType.CUSTOMER]: "Kunde",
    [UserType.TAXCONSULTANT]: "Steuerberater",
    [UserType.AGENCY]: "Agentur",
};

export const UserModalMode = {
    REGISTER: "REGISTER",
    EDIT: "EDIT",
};
